import { observable, action } from 'mobx';
import BaseStore from 'store/BaseStore';

// strange: this line must stay but is not used
// eslint-disable-next-line
import { uploadVideo } from 'utils/api';
import { uploader } from '../../../services/uploader';

export default class FileUploadStore extends BaseStore {
  @observable uploadProgress;
  @observable currentFileUpload = 0;
  @observable totalFileUpload = 0;
  @observable canDrop = true;

  constructor(uiState) {
    super();
    this.uiState = uiState;
  }

  async uploadVideos(files) {
    this.setUploadProgress(0);
    this.setTotalFileUpload(files.length);
    this.setCurrentFileUpload(0);
    this.setAcceptState(false);
    const response = await uploader({
      files,
      onComplete: ({ successFiles, failedFiles }) => {
        this.setUploadDone();

        if (successFiles.length === files.length) {
          this.uiState.createAlert({
            ok: 'OK',
            title: 'Uploaden en transcoden',
            message:
              'De video(s) is/zijn succesvol opgeladen maar moet nu nog getranscodeerd worden. Deze is afhankelijk van de grootte van de video kan dit langer duren.<br><br>Na de voorbereidingen komt deze in uw overzicht te zien. U krijgt hiervan een bevestigingsmail.'
          });
        } else if (successFiles.length === 0) {
          this.uiState.createAlert({
            ok: 'OK',
            title: 'Uploaden mislukt',
            message: 'De video(s) is/zijn gefaald om op te laden.'
          });
        }
      },
      onProgress: e => this.onProgressHandler(e)
    });

    return response;
  }

  @action
  setUploadDone = () => {
    this.canDrop = true;
    this.currentFileUpload = 0;
    this.uploadProgress = 0;
    this.totalFileUpload = 0;
  };

  @action
  setAcceptState = value => {
    this.canDrop = value;
  };

  @action
  setUploadProgress(value) {
    this.uploadProgress = value;
  }

  @action
  setCurrentFileUpload(value) {
    this.currentFileUpload = value;
  }

  @action
  setTotalFileUpload(value) {
    this.totalFileUpload = value;
  }

  @action
  onProgressHandler(progressEvent) {
    const { loadedFiles, totalProgress } = progressEvent;
    this.uploadProgress = totalProgress;
    this.currentFileUpload = loadedFiles;
  }
}



// WEBPACK FOOTER //
// ./src/containers/analyse/store/FileUploadStore.js